import { Component, Inject } from '@angular/core';
import {  MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Finestra per configurar els paràmetres de l'usuari sobre el consum del seu vehicle per fer la ruta
 */
@Component({
  selector: 'app-fuel-dialog',
  templateUrl: './fuel-dialog.component.html',
  styleUrls: ['./fuel-dialog.component.css']
})
export class FuelDialogComponent {

  /**
   * Constructor del component
   * @param {MatDialogRef<FuelDialogComponent>} dialogRef Inicialitza la finestra amb aquest component
   * @param {any} data Conté les dades que l'usuari pot configurar, com el combustible, el tipus de vehicle... 
   */
  constructor(public dialogRef: MatDialogRef<FuelDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  /**
   * Tipus de vehicle 
   */
  tipusVehicle: string = this.data.tipusVehicle;

  /**
   * Consum del vehicle
   */
  consumVehicle: number = this.data.consumVehicle;

  /**
   * Combustible que fa servir el vehicle
   */
  combustible: string = this.data.combustible;

  /**
   * Preu del combustible actual
   */
  preuCombustible: number = this.data.preuCombustible;

  /**
   * Tanca la finestra de configuració
   */
  closeDialog() {
    this.dialogRef.close({
      saved: false
    });
  }

  /**
   * Tanca la finestra d'informació i guarda els canvis que ha fet l'usuari en els paràmetres configurables
   */
  save() {
    this.dialogRef.close({
      saved: true,
      tipusVehicle: this.tipusVehicle,
      consumVehicle: this.consumVehicle,
      combustible: this.combustible,
      preuCombustible: this.preuCombustible
    })
  }

}
